import BrandIcon from './BrandIcon';

/**
 * BrandWordmark
 *
 * Canonical GroovLens lockup used everywhere the company name appears.
 *
 *   [● icon]  GroovLens
 *                by Beatseek   (small, italic, muted, right-aligned under wordmark)
 *
 * The icon is rendered as inline SVG (BrandIcon component) so we can flip
 * variants (black-vinyl / white-vinyl) app-wide by changing a single prop.
 * The PWA install tile still ships as the icon-192.png in the manifest —
 * if the trial variant is approved, regenerate the PNGs to match.
 *
 * Props:
 *   - size: 'sm' | 'md' | 'lg'   visual scale of the wordmark
 *   - showIcon: boolean          show/hide the logo tile to the left of the wordmark
 *   - iconVariant: 'black' | 'white'   which vinyl style to render (see BrandIcon)
 *   - subtitleClassName: string  optional override for the subtitle
 *   - className: string          wrapper class additions
 */
export default function BrandWordmark({
  size = 'md',
  showIcon = true,
  iconVariant = 'teal-disc',
  className = '',
  subtitleClassName = '',
}) {
  const wordmarkSize =
    size === 'lg' ? 'text-xl' : size === 'sm' ? 'text-base' : 'text-lg';
  const iconPx =
    size === 'lg' ? 38 : size === 'sm' ? 28 : 34;
  const subtitleSize =
    size === 'lg' ? 'text-[11px]' : 'text-[10px]';

  return (
    <span
      className={`inline-flex items-center gap-1.5 ${className}`}
      data-testid="brand-wordmark"
    >
      {showIcon && (
        <BrandIcon
          variant={iconVariant}
          size={iconPx}
          className="rounded-md shrink-0"
          data-testid="brand-wordmark-icon"
        />
      )}
      <span className="flex flex-col leading-none">
        <span
          className={`font-display ${wordmarkSize} font-semibold tracking-tight`}
        >
          GroovLens
        </span>
        <span
          className={`${subtitleSize} italic text-muted-foreground/80 tracking-wide -mt-1.5 leading-tight self-end ${subtitleClassName}`}
          data-testid="brand-subtitle"
        >
          by Beatseek
        </span>
      </span>
    </span>
  );
}
